// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application .btn-disabled[data-v-78feb904]{background-color:rgba(0,0,0,0) !important;color:gray !important}", ""]);
// Exports
module.exports = exports;
